
import { Component, Prop, Vue, Watch } from '~/utility/pu-class-decorator'
import type BaseRadio from '~~/components/base/BaseRadio.vue'
import type { SortOptions } from '../../schemas'

@Component
export default class FilterAndSortSortOptions extends Vue {
  @Prop()
    options: SortOptions[]

  @Prop()
    selected: string

  @Prop()
    panelOpen: boolean

  radioSelectedOption: SortOptions | null = null

  selectedChanged(selected: string) {
    this.radioSelectedOption = selected
    if (this.selected !== selected) {
      this.$emit('update', selected)
    }
  }

  @Watch('selected', { immediate: true })
  updateSelected() {
    this.radioSelectedOption = this.selected
  }

  $refs: {
    'sort-options': BaseRadio[]
    'sort-option-wrapper': HTMLDivElement
  }

  @Watch('panelOpen')
  panelOpenChanged(newVal) {
    if (newVal) {
      const selected = this.$refs['sort-options']?.find((el) => {
        return el.value === this.selected
      })

      if (selected && this.$refs['sort-option-wrapper']) {
        const elementOffset = Math.round(
          (selected.$el as HTMLElement).offsetLeft - 16,
        )
        this.$refs['sort-option-wrapper'].scrollLeft = elementOffset
      }
    }
  }

  get sortOptions() {
    const keys = Object.keys(this.sortOptionsMap)
    if (this.options && this.options.length) {
      return this.options.filter((opt) => keys.includes(opt))
    }
    return keys
  }

  sortOptionsMap = {
    '-rating': 'User rating',
    distance: 'Distance',
    magic: 'Our favourites',
    price: 'Price',
    '-price': 'Price',
  }

  getSortIcon(option: string) {
    const icons = {
      price: 'ascending.svg',
      '-price': 'descending.svg',
    }
    const hasIcon = Object.keys(icons).includes(option)
    if (hasIcon) {
      try {
        return require(`@/assets/images/${icons[option]}`)
      } catch {
        return undefined
      }
    }
  }
}
